/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-10-26 13:48:39 */

const Keys = {
  bannerText: 'bannerText',
  close: 'close',
  location: 'location',
  from: 'from',
  showHotel: 'showHotel',
  MAP: 'MAP',
  ariaMapLabel: 'ariaMapLabel',
  ariaDetailsPrefix: 'ariaDetailsPrefix',
  toggleFullscreenView: 'toggleFullscreenView',
  exitFullscreenView: 'exitFullscreenView'
}; export default Keys;